import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import useAuth from '../../hooks/useAuth';
import './News.css';
import { SITE_TITLE } from '../../utils/constants';
import { seo } from '../../utils/seo';
import GearSpinner from '../../components/GearSpinner/GearSpinner';
import NewsServices from '../../services/NewsService';
import associateImg from '../../assets/images/associate-img.png';

const DetailsPage = () => {
	const { user } = useAuth();
    const { permalink } = useParams();
	const [showSpinner, setShowSpinner] = useState(1);
	const [newsData, setNewsData] = useState([]);


	const newsServices = new NewsServices();

	useEffect(() => {
		seo({
			title: SITE_TITLE + ' || Dashboard',
			metaDescription: '',
		});
		getNews();
	}, [user]);

	const getNews = () => {
		newsServices.getNewsDetails({portal_user_id : user.id},permalink).then((response) => {
			setShowSpinner(0);
			if (response.status === 200) {
				setNewsData(response.data);
			} else {
				setNewsData([]);
			}
		});
	}
	
	return(
		<React.Fragment>
			<main className="techtop-middle-div">
				<section className="techtop-news-section pb-5">
					<div className="container">
						{/* Page Title */}
						<div className="row">
							<div className="col-md-12">
								<div className="techtop-default-title2">
									<div className="row">
										<div className="col-md-6">
											<h1 className="m-0 dark-color1">Techtop News</h1>
										</div>
										<div className="col-md-6 text-end">
											<h1 className="m-0 dark-color1">{user.name}</h1>
										</div>
									</div>
								</div>
                                <div className="row">													 
									
                                    {showSpinner === 1 && 
										<React.Fragment>
											<div className="col-md-12 mt-5">
												<GearSpinner/>
												</div>
										</React.Fragment>
									}
									{newsData.status === 'fail' && showSpinner === 0 &&
										<React.Fragment>
											<div className="col-md-12 mt-5">
												<h4 className="mb-3 text-center">{newsData.message}</h4>
											</div>
										</React.Fragment>
									}
                                    {newsData.status === 'success' && showSpinner === 0 &&
                                        <React.Fragment>
                                            <div className="col-md-12 mt-3">
                                                <h4 className="mb-3 red-text">{newsData.result.title}</h4>
                                                <div className="author-name">
                                                    <img src={associateImg} className="img-fluid" />
                                                    <p>{newsData.result.author}</p>
                                                </div>	
                                                <small className="gray-txt">Published {moment(newsData.result.created_at).format('M/D/yyyy')}</small>
                                            </div>
                                            <div className="col-md-12 mt-4">
                                                <div className="techtop-news-div2" dangerouslySetInnerHTML={{ __html: newsData.result.content }} />
                                            </div>
                                        </React.Fragment>
                                    }
                                    
								</div>
							</div>
						</div>
					</div>
				</section>
			</main>
		</React.Fragment>
	)
}

export default DetailsPage;